import { useQuery, useQueryClient } from "@tanstack/react-query";

import { DEFAULT_CACHE_TIME, FOOTPRINTING_AUTOFILL_APPLIED } from "consts";

export const useWasAutofilled = (type: string, farmId: string, year: number, cropId?: string): boolean => {
  const queryClient = useQueryClient();
  const queryKey = cropId ? [FOOTPRINTING_AUTOFILL_APPLIED, type, farmId, cropId, year] : [FOOTPRINTING_AUTOFILL_APPLIED, type, farmId, year];

  const { data } = useQuery(
    {
      queryKey,
      queryFn: () => false,
      staleTime: DEFAULT_CACHE_TIME,
    },
    queryClient
  );

  return data ?? false;
};
